import * as React from 'react'
import * as Tgcc from '../tgccGlobal'
import {CSSProperties} from 'react'
import {connect} from 'react-redux'
import Radium, { StyleRoot } from 'radium'
import {Checkbox} from '../Components/Checkbox'

let wrapperStyle: CSSProperties = {
    fontFamily: 'CenturyGothic',
    fontSize: '18px',
    textTransform: 'uppercase',
    maxWidth: '700px',
    alignSelf: 'center',
    margin:'20px auto 10px auto',
    '@media (max-width:414px)': {
        fontSize:'11px',
        width:'95%'
    },
    '@media (max-width:412px)': {
        fontSize:'9px'
    },
    '@media (max-width:375px)': {
        fontSize:'9px',
    },
    '@media (max-width:360px)': {
        fontSize:'7px'
    },
    '@media (max-width:320px)': {
        fontSize:'8px'
    }
}
let subheadStyle: CSSProperties = {
    letterSpacing: '0.3em',
    fontSize: '15px',
    display: 'flex',
    alignSelf: 'center',
    color:'#323232',
    fontFamily:'AveriaSerifLightItalic'
}
let loginStyle: CSSProperties = {
    letterSpacing: '3px',
    fontSize: '12px',
    display: 'flex',
    alignSelf: 'center',
    cursor: 'pointer'
}
let rowStyle: CSSProperties = {
    padding: '15px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
}
let checkRowStyle = Object.assign({},rowStyle,{position:'relative',marginBottom:'15px'})
let rowWithCheckStyle: CSSProperties = {
    padding: '15px',
    display: 'flex',
    flexDirection: 'row',
}
let labelStyle: CSSProperties = {
    letterSpacing: '1px',
    display: 'flex',
    alignSelf: 'flex-start',
    fontWeight: 100,
    margin: 0,
    color: Tgcc.Styles.darkTextColor,
    lineHeight: '35px',
    fontFamily: 'Reitam',
}
let inputStyle: CSSProperties = {
    display: 'flex',
    flexGrow: 2,
    marginLeft: '6px',
    padding: '0 5px',
    lineHeight: '35px',
    height: '35px',
    border:'2px solid #E9E6E6',
    fontFamily:'AveriaSerifLightItalic',
    '@media (max-width:414px)': {
        lineHeight:'25px'
    }
}
let checkStyle: CSSProperties = {
    display: 'flex',
    marginLeft: '8px',
    padding: '0 5px',
    lineHeight: '35px',
    height: '20px',
    width: '20px',
    alignSelf: 'center',
    border:'2px solid #E9E6E6',
    fontFamily:'AveriaSerifLightItalic',
    '@media (max-width:414px)': {
        lineHeight:'25px',
        height: '15px',
        width: '15px'
    }
}
let fieldBoxStyle: CSSProperties = {
    paddingTop: '15px',
    paddingBottom: '15px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
}
let checkCont: CSSProperties = {
    display:'inline-block'
}
let checkCont1 = Object.assign({},checkCont,{marginRight:'100px'});

const rushFee: CSSProperties = {
    position:'absolute',
    top:'60px',
    left:'50%',
    marginLeft:'-100px',
    color:'red',
    fontFamily:'Reitam'
}
const qtyCheck = Object.assign({},rushFee,{marginLeft:'-190px'});

class ProofInfoState {
    proof: Tgcc.Proof;
    user: Tgcc.UserInfo;
    password: string;
    confirmPassword: string;
}

class _CatalogInfo extends React.Component<Tgcc.BaseProps, any>{

    state: ProofInfoState = new ProofInfoState;

    componentWillMount(){
        this.loadState(this.props);
    }

    componentWillReceiveProps(newProps: Tgcc.BaseProps){
        this.loadState(newProps);
        this.state.proof.phone = this.state.user.phone;
        this.state.proof.smsAllowed = this.state.user.smsAllowed;
    }

    loadState = (newProps: Tgcc.BaseProps) => {
        this.setState({
            proof: newProps.state.ActiveProof,
            user: newProps.state.UserInfo
        });
    }

    proofDataChanged = (evt: React.FormEvent<HTMLInputElement>) =>{
        var proof = this.state.proof;
        var name = evt.currentTarget.name;
        if(name == 'smsAllowed' )
            proof[name] = evt.currentTarget.checked;
        else
            proof[name] = evt.currentTarget.value;
        this.props.dispatch({type: Tgcc.StateAction.UpdateProof, payload: proof})
    }
    formatDate = (date:Date,days:number) => {
        var monthNames = [
            "01", "02", "03",
            "04", "05", "06", "07",
            "08", "09", "10",
            "11", "12"
        ];

        var day = date.getDate() + days;
        var monthIndex = date.getMonth();
        var year = date.getFullYear();
        var today = year + '-' + monthNames[monthIndex] + '-' + day;

        return today;
}
    onSelectDivision = (evt: React.FormEvent<HTMLSelectElement>) => {
    this.props.dispatch({type: Tgcc.StateAction.UpdateProofDivision, payload:evt.currentTarget.value});
}
    onSelectContact = (evt: React.FormEvent<HTMLSelectElement>) => {
    this.props.dispatch({type: Tgcc.StateAction.UpdateProofSalesContact, payload:evt.currentTarget.value});
}

    render(){
        var proof: Tgcc.Proof = this.state.proof;
    
        var loginSuggestion = null, passwordPrompt = null; 
        var loginData = this.props.state.LoginData;
        var userInfo = this.props.state.UserInfo;
     

        return (
            <div style={wrapperStyle} className="campusProofInfo">
                <div style={fieldBoxStyle}>
                    <div style={rowStyle}>
                        <label className="labelStyle" style={labelStyle}>Name:</label>
                        <input type='text' style={inputStyle} name='eventName' onChange={this.proofDataChanged} value={proof.eventName||""} />
                    </div>
                    <div style={checkRowStyle}>
                        <label className="labelStyle" style={labelStyle}>Due Date:</label>
                        <input type='date' style={inputStyle} name='inHandsDate' placeholder="01/02/1990" onChange={this.proofDataChanged} value={proof.inHandsDate || ""}/>
                    </div>
                    <div style={checkRowStyle}>
                        <label className="labelStyle" style={labelStyle}>Division:</label>
                        <select onChange={this.onSelectDivision} name="division" style={inputStyle}>
                                    <option key={4} value={""}></option>
                                    <option key={0} value={"Campus"}>Campus</option>
                                    <option key={1} value={"Major Accounts"}>Major Accounts</option>
                                    <option key={2} value={"Indigo Island"}>Indigo Island</option>
                                    <option key={5} value={"Indigo Lifestyle"}>Indigo Lifestyle</option>
                                    <option key={3} value={"Struttin Cotton"}>Struttin Cotton</option>                               
                                </select>
                    </div>
                    <div style={checkRowStyle}>
                    <label className="labelStyle" style={labelStyle}>Requester:</label>
                        <select onChange={this.onSelectContact} name="requester" style={inputStyle}>
                            <option key={-1} value={""}></option>
                            <option key={0} value={"Madyson Mitchell"}>Madyson Mitchell</option>
                            <option key={1} value={"Krystle Lopez"}>Krystle Lopez</option>
                            <option key={2} value={"Katie Massey"}>Katie Massey</option>
                            <option key={3} value={"Anna Rutherford"}>Anna Rutherford</option>
                            <option key={4} value={"Andy Coyne"}>Andy Coyne</option>
                            <option key={5} value={"Jim Hendrix"}>Jim Hendrix</option>
                            <option key={6} value={"Bev Ellison"}>Bev Ellison</option>
                            <option key={7} value={"Kent Barber"}>Kent Barber</option>
                            <option key={8} value={"Devin Householder"}>Devin Householder</option>
                            <option key={9} value={"Steve Parnell"}>Steve Parnell</option>
                            <option key={10} value={"Ashley Furgeson"}>Ashley Furgeson</option>
                            <option key={11} value={"Ben Kilgore"}>Ben Kilgore</option>
                            <option key={12} value={"Jami Widmyer"}>Jami Widmyer</option>
                        </select>

                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: Tgcc.GlobalState, ownState: any) => {
    return { state: state }
};
export var CatalogInfo = connect(mapStateToProps)(Radium(_CatalogInfo));
